import DOMPurify from "dompurify";
import "../styleSheet/ViewJob.css";

const ViewJob = ({ job, onClose, apply, userEmail }) => {
    
    if (!job) return null;
    const buildCombinedDescription = () => {
        const descriptionField = job.description;

        // If API returns a plain HTML string in job.description, sanitize and return it as is
        if (typeof descriptionField === "string" && descriptionField.trim() !== "") {
            return DOMPurify.sanitize(descriptionField);
        }

        // Collect possible sources (support either nested under description or top-level)
        const jobDescriptionHtml = (descriptionField && descriptionField.job_description) || job.job_description || "";
        const requirementsHtml = (descriptionField && descriptionField.requirements) || job.requirements || "";
        const benefitsHtml = (descriptionField && descriptionField.benefits) || job.benefits || "";

        // If nothing present, fallback text
        if (!jobDescriptionHtml && !requirementsHtml && !benefitsHtml) {
            return "No description available";
        }

        // Build a single combined HTML block with sub-headings
        const combinedHtml = `
            ${jobDescriptionHtml ? `<h4>Job Description</h4>${jobDescriptionHtml}` : ""}
            ${requirementsHtml ? `<h4>Requirements</h4>${requirementsHtml}` : ""}
            ${benefitsHtml ? `<h4>Benefits</h4>${benefitsHtml}` : ""}
        `;

        return DOMPurify.sanitize(combinedHtml);
    };

    const sanitizedDescription = buildCombinedDescription();

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h2 className="job-title">{job.title}</h2>
                <div className="job-info-container">
                    <div className="job-description">
                        {/* <h3>Job Description</h3> */}
                        <div dangerouslySetInnerHTML={{ __html: sanitizedDescription }} />
                    </div>
                    <div className="job-details">
                        <h3>Job Information</h3>
                        <InfoRow label="Date Opened:" value={new Date(job.posted_date).toLocaleDateString()} />
                        <InfoRow label="Job Type:" value={job.type} />
                        <InfoRow label="Work Experience:" value={`${job.Experience}-${job.Experience_max} Years`} />
                        <InfoRow label="City:" value={job.city || "-"} />
                        <InfoRow label="State/Province:" value={job.state || "-"} />
                        <InfoRow label="Country:" value={job?.country || "-"} />
                        <InfoRow label="Zip/Postal Code:" value={job?.pincode || "-"} />
                        <InfoRow label="Number of Positions:" value={job.positions || "1"} />
                    </div>
                </div>
                <div className="action-buttons">
                    {job.apply && (
                        <button className="apply-button" onClick={() => window.location.href = `${process.env.REACT_APP_JOBS_SITE_URL}JobApplication/${job.webform}?jobtitle=${job.title}&jobid=${job.id}&user=${userEmail}&assesment=${job.assesment}`}>I'm Interested</button>
                    )}
                </div>
                <button className="close-button" onClick={onClose}>✕</button>
            </div>
        </div>
    );
};

const InfoRow = ({ label, value }) => (
    <div className="info-row">
        <span className="info-label">{label}</span>
        <span className="info-value">{value}</span>
    </div>
);

export default ViewJob;
